'use client'

import { useEffect, useRef, useState } from 'react'

// Mounts children only when the placeholder approaches the viewport. Pair
// with next/dynamic({ ssr: false }) children so their chunks download on
// approach instead of piling onto first-load hydration (the mobile TBT/LCP
// killer). The margin is deliberately under one phone-viewport-stack: any
// larger and the first below-fold sections intersect at load, mounting
// everything anyway and defeating the deferral.
export default function LazyMount({ children, rootMargin = '500px', minHeight }) {
  const ref = useRef(null)
  const [show, setShow] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (!('IntersectionObserver' in window)) {
      setShow(true)
      return
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShow(true)
          io.disconnect()
        }
      },
      { rootMargin },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [rootMargin])

  if (show) return children
  return <div ref={ref} style={minHeight ? { minHeight } : undefined} aria-hidden />
}
